import axiosClient from "./axiosClient";

// Wrapper de /ventas/demos (agendas de demo de televenta).
// El interceptor de axiosClient devuelve response.data directamente.

export async function scheduleDemo(payload) {
  const r = await axiosClient.post("/ventas/demos", payload);
  return r?.data ?? r;
}

export async function listDemos(params = {}) {
  const r = await axiosClient.get("/ventas/demos", { params });
  const data = r?.data ?? r;
  return Array.isArray(data?.demos) ? data.demos : [];
}

export async function listDemosForLead(leadContactId) {
  if (!leadContactId) return [];
  return listDemos({ lead_contact_id: leadContactId });
}

export async function updateDemo(payload) {
  const r = await axiosClient.put("/ventas/demos", payload);
  return r?.data ?? r;
}

export async function deleteDemo(demo_id) {
  const r = await axiosClient.delete("/ventas/demos", { params: { demo_id } });
  return r?.data ?? r;
}
